module.exports = __webpack_public_path__ + "img/userInputBlack.3e3230f1.svg";